// src/Hooks/useHasPermission.js
import { useHasAccess } from 'Routes/hooks/useHasAccess';

/**
 * useHasPermission
 *
 * Convenience wrapper around useHasAccess for a single "resource:action" key.
 *
 * @param {string} key - e.g. 'jobs_library-job_details:edit'
 * @returns {boolean}
 *
 * @example
 *   const canEdit = useHasPermission('jobs_library-job_details:edit');
 */
export const useHasPermission = (key) => {
    const { hasAccess } = useHasAccess();
    const [resource, action] = key.split(':');
    return hasAccess(resource, action ? [action] : []);
};
